module.exports = __webpack_public_path__ + "img/object_one.81db747a.png";